var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChatIcon5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 34.51 21.14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:#a7b9c5;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(5 5)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.73,11.14V7.58h4.19V4.74H19.73V2.83h4.78V0H16.34V11.14Zm-4.75,0V0H12.25V11.14Zm-9,0a9.18,9.18,0,0,0,2.45-.35,7.33,7.33,0,0,0,2.19-1V5.28H7.47V8a3.43,3.43,0,0,1-1.31.25A2.42,2.42,0,0,1,4.31,7.5a2.68,2.68,0,0,1-.69-1.93,2.66,2.66,0,0,1,.7-1.95,2.56,2.56,0,0,1,1.89-.71A3.06,3.06,0,0,1,8.6,4.08l2.29-2A5.26,5.26,0,0,0,8.83.53,7.11,7.11,0,0,0,6,0,6.75,6.75,0,0,0,2.91.71a5.25,5.25,0,0,0-2.14,2A5.44,5.44,0,0,0,0,5.57,5.44,5.44,0,0,0,.77,8.45a5.26,5.26,0,0,0,2.12,2A6.51,6.51,0,0,0,6,11.14Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    width: 34.51,
    height: 21.14
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatIcon5);
export default __webpack_public_path__ + "static/media/chat-icon5.0217251994a57ba572ded07c07dbe902.svg";
export { ForwardRef as ReactComponent };